import React from 'react';
// import banner from '../../images/about-bg.png';
import './About.css'

const About = () => {
    return (
        <div className='container'>
            <div className='title'>
                <h4>Hi! I'm</h4>
                <h2>Shakhawath</h2>
            </div>
            <div className='about-info'>
                <p>Hi! I'm shakhawath. I am studing web development with 'Programming-Hero'. I want to be a full-stack web developer. So, I'm hard working on it. I want to build the qualityfull web sites for clients. I want to learn update technology about web development, for provide better projects.I want to use my highest knowledge in the workplace. Also help new lerner.</p>
            </div>
        </div>
    );
};

export default About;